import React, { useState } from "react";
import ModalBootstrap from "../modal/ModalBootstrap";
import MapGoogle from "./MapGoogle"; // Asegúrate de que la ruta sea correcta


const VerUbicacion = ({direccion, textoBoton}) => {
    const apiKey = "AIzaSyCGXF5gopo3pYCSblAPuGRBYUB54BTSQos"; // Reemplaza con tu API Key de Google Maps

    const [mapCenter, setMapCenter] = useState({
        lat: parseFloat(direccion?.latitud) || 14.1,
        lng: parseFloat(direccion?.longitud) || -87.21,
    });
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <>
            <ModalBootstrap
                titulo={"Seleccionar Ubicación"}
                nombreBoton={textoBoton}
                estiloBoton={"btn btn-info mr-2"}
                iconBoton={"fas fa-map-marker-alt mr-1"}
                modalIsOpen={isModalOpen}
                setModalIsOpen={setIsModalOpen}
            >
                <MapGoogle
                    center={mapCenter}
                    zoom={9}
                    apiKey={apiKey}
                />
                <div className="card-body">
                    <strong><i className="fas fa-map-marker-alt mr-1" /> Direccion</strong>
                    <p>
                        {direccion.direccion}
                    </p>
                </div>
            </ModalBootstrap>
        </>
    );
};

export default VerUbicacion;